var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"movieverse-app"},[_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":"","color":"#151821"},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),(_vm.user)?_c('Header'):_vm._e(),_vm._v(" "),_c('v-main',[_c('div',{staticClass:"app-shell",attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath,on:{"errorListener":_vm.showError}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42e107f9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 83
// module chunks = 0